import Controller from "../../../../core/js/Controller";

export default class Album extends Controller {
    constructor() {
        super();
    }

    afterInit() {
        lightGallery(this.container);
    }
}